export class AudioService {

    audioPlayer: HTMLAudioElement;

    constructor() {
        this.audioPlayer = new Audio("assets/sounds/solemn.mp3");
    }

    public soundAlarm() {
        // if this sends before first user interaction it will throw exception
        try {
            this.audioPlayer.play();
        }
        catch (e) {
        }
    }
}
